'use client';

import { routerPushI18n } from '@repo-ui/router';
import { useEffect } from 'react';

export default function Page() {
  useEffect(() => {
    routerPushI18n('/gallery/list/blk/all');
  }, []);

  return null;
}
